import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../../service/order.service';
import { InvoiceService } from '../../../service/invoice.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Message } from 'primeng/components/common/api';

@Component({
  selector: 'app-supplier-invoice-list',
  templateUrl: './supplier-invoice-list.component.html',
  styleUrls: ['./supplier-invoice-list.component.css']
})
export class SupplierInvoiceListComponent implements OnInit {

  invoices: any[];
  cols = [
      { field: 'InvoiceType', header: 'סוג מסמך', width: '100', priority: '' },
      { field: 'InvoiceNumber', header: 'מספר מסמך', width: '100', priority: '' },
      { field: 'OrderNumber', header: 'מספר הזמנה', width: '140', priority: 'ui-p-2' },      
      { field: 'InvoiceStatus', header: 'סטטוס', width: '100', priority: 'ui-p-2'   },
      { field: 'InvoiceDate', header: 'תאריך מסמך', width: '100', priority: 'ui-p-3'  },
      // { field: 'Quantity', header: 'כמות', width: '80', priority: 'ui-p-6'   },
      // { field: 'UnitePrice', header: 'מחיר ליחידה', width: '80', priority: 'ui-p-6'   },
      // { field: 'Total', header: 'סה"כ', width: '80', priority: 'ui-p-6'   },
      { field: 'TotalWithTax', header: 'סה"כ כולל מע"מ', width: '80', priority: 'ui-p-6'   },
      { field: 'SupplierName', header: 'שם ספק', width: '120', priority: 'ui-p-6' },      
      // { field: 'CreateUserName', header: 'הוגש ע"י', priority: 'ui-p-6' },      
  ];

  // treatmentTypes: any[] = [{value: '0', label: 'בכל שלבי טיפול'},{value: '1', label: 'ממתין לטיפולי'}];
  // treatmentTypeSelected = this.treatmentTypes[1].value;

  filterOrderNumber: any;
  // filterSupplier: any;
  filterOrderStatus: any;
  filterDateFrom: any;
  filterDateTo: any;

  // suppliersOptions: any[] = [];
  orderStatusOptions: any[] = [];

  invoiceTypes: any[];
  invoiceTypeSelected: any;


  showInvoicePreviewDialog: boolean = false;
  currentInvoiceDetails: any;

  msgs: Message[] = [];


  constructor(private orderService: OrderService, private invoiceService: InvoiceService) { }

  ngOnInit() {

    this.filterOrderNumber = null;

    // this.filterSupplier = null;
    // this.orderService.GetCustomerSuppliers().subscribe((result: any) => {
    //   this.suppliersOptions = result;
    // },
    //   (err: HttpErrorResponse) => {
    //     this.showMessage('error', '', 'תקלה בקבלת רשימת ספקים ');
    // });

    this.filterOrderStatus = null;
    this.invoiceService.GetSupplierInvoiceStatuses().subscribe((result: any) => {
      this.orderStatusOptions = result;
      // this.orderStatusOptions.unshift({ label: 'הכל', value: null });

    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת סטטוסים ');
    });

    this.invoiceTypes = [{value: '1', label: 'חשבונית'},{value: '2', label: 'דוח שרות'},{value: '3', label: 'תעודת משלוח'}];
    this.invoiceTypeSelected = null;
    
    let fromD = new Date((new Date()).getFullYear(), 0, 1);
    this.filterDateFrom = new Date(Date.UTC(fromD.getFullYear(), fromD.getMonth(), fromD.getDate()));
    this.filterDateTo = new Date();


    this.getSupplierInvoices();
  }

  getSupplierInvoices() {
    let invoiceFilter = {
      OrderNumber: this.filterOrderNumber,
      // SupplierId: this.filterSupplier ? this.filterSupplier.Id : null,
      InvoiceStatusId: this.filterOrderStatus,
      InvoiceDateFrom: this.filterDateFrom ? new Date(Date.UTC(this.filterDateFrom.getFullYear(), this.filterDateFrom.getMonth(), this.filterDateFrom.getDate())) : null,
      InvoiceDateTo: this.filterDateTo ? new Date(Date.UTC(this.filterDateTo.getFullYear(), this.filterDateTo.getMonth(), this.filterDateTo.getDate())) : null,
      // TreatmentType: this.treatmentTypeSelected

    };
    this.invoiceService.getSupplierInvoices(invoiceFilter).subscribe((result: any) => {
      this.invoices = result;
    },
      (err: HttpErrorResponse) => {
        let errMessage = (err.error && err.error.ExceptionMessage) ? err.error.ExceptionMessage : 'תקלה בקבלת נתונים ';
        this.showMessage('error', '', errMessage);
      });
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: ' העדכון נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בעדכון' });
  }

  showFile(invoice) {

      this.currentInvoiceDetails = invoice;
      this.showInvoicePreviewDialog = true;

  }

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/invoice/supplier-invoice/supplier-invoice-list/supplier-invoice-list.component.ts